// Environment configuration for the frontend
const config = {
  // API Configuration
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://rt7g3lhbgfraw6eugzcxx6dzwm0nvuom.lambda-url.ap-south-1.on.aws',
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 30000,
    apiKey: process.env.REACT_APP_API_KEY || null,
  },
  
  // Feature flags
  features: {
    enableLogging: process.env.REACT_APP_ENABLE_LOGGING !== 'false',
    enableDebugMode: process.env.REACT_APP_DEBUG_MODE === 'true',
  },
  
  // Development settings
  development: {
    mockApi: process.env.REACT_APP_MOCK_API === 'true',
    showApiCalls: process.env.REACT_APP_SHOW_API_CALLS === 'true',
  },
};

// Validate required environment variables
const validateConfig = () => {
  const warnings = [];
  
  if (!process.env.REACT_APP_API_BASE_URL) {
    warnings.push('REACT_APP_API_BASE_URL not set, using default: https://rt7g3lhbgfraw6eugzcxx6dzwm0nvuom.lambda-url.ap-south-1.on.aws');
  }
  
  if (warnings.length > 0 && config.features.enableLogging) {
    console.warn('[Config] Environment warnings:', warnings);
  }
  
  return warnings;
};

// Initialize configuration
const initConfig = () => {
  const warnings = validateConfig();
  
  if (config.features.enableLogging) {
    console.log('[Config] Environment configuration loaded:', {
      apiBaseUrl: config.api.baseUrl,
      timeout: config.api.timeout,
      enableLogging: config.features.enableLogging,
      debugMode: config.features.enableDebugMode,
    });
  }
  
  return { config, warnings };
};

export default config;
export { validateConfig, initConfig };
